/* eslint-disable @repo/internal/react/use-primitives */
/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/react';
import useScrollbarWidth from '@atlaskit/ds-lib/use-scrollbar-width';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
import { containerCSS, innerContainerCSS, outerContainerCSS } from './styles';
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
var NavigationContent = /*#__PURE__*/forwardRef(function (props, ref) {
  var showTopScrollIndicator = props.showTopScrollIndicator,
    children = props.children,
    testId = props.testId;
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  var scrollbar = useScrollbarWidth();
  if (!shouldRender) {
    return children;
  }
  var typedRef = ref;
  return jsx("div", {
    ref: typedRef,
    css: outerContainerCSS({
      showTopScrollIndicator: showTopScrollIndicator,
      scrollbarWidth: scrollbar.width
    }),
    "data-testid": testId
  }, jsx("div", {
    ref: scrollbar.ref,
    css: innerContainerCSS({
      showTopScrollIndicator: showTopScrollIndicator
    })
  }, jsx("div", {
    css: containerCSS({
      showTopScrollIndicator: showTopScrollIndicator
    })
  }, children)));
});
export default NavigationContent;